<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <h1>{{ pageName }}</h1>
            </div>
        </div>
        <div *ngIf="officeName">Studio: {{ officeName }}</div>
    </div><!-- /.container-fluid -->
</section>